import * as React from 'react';
import styled from 'styled-components';

export class Divider extends React.Component {
  render() {
    return <DividerComponent />;
  }
}

const DividerComponent = styled.div`
  background: url(${process.env.REACT_APP_URL}/images/background.png);
  width: 100%;
  height: 30px;
  background-size: 600px;
`;
